import React, { useState, useEffect } from "react";
import { X, Loader2 } from "lucide-react";
import FormField from "../ui/FormField";

interface EditCustomerPackageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (minutes: number) => void;
  currentMinutes: number;
}

export const EditCustomerPackageModal = ({
  isOpen,
  onClose,
  onUpdate,
  currentMinutes,
}: EditCustomerPackageModalProps) => {
  const [minutes, setMinutes] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      setMinutes(currentMinutes.toString());
      setError(null);
    }
  }, [isOpen, currentMinutes]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const val = parseInt(minutes);
    if (isNaN(val)) {
      setError("Please enter a valid number of minutes.");
      return;
    }
    if (val < 0) {
      setError("Remaining minutes cannot be negative.");
      return;
    }
    if (val > currentMinutes) {
      setError(
        `New remaining minutes (${val}) cannot be greater than the current balance (${currentMinutes}).`
      );
      return;
    }

    setError(null);
    onUpdate(val);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-lg w-full max-w-lg flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {/* Header */}
        <div className="px-6 py-4 border-b border-[#885ABB] flex justify-between items-center bg-[#885ABB] rounded-t-xl">
          <h2 className="text-xl font-bold text-white">
             Edit Customer Package
          </h2>
          <button 
            onClick={onClose} 
            className="text-white/80 hover:text-white hover:bg-white/10 p-1 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="space-y-2">
            <FormField
              label="Remaining Minutes:"
              name="minutes"
              type="number"
              value={minutes}
              onChange={(_, val) => setMinutes(val)}
              className="w-full" // FormField usually handles full width but just in case
            />
            {error && (
              <p className="text-xs text-red-600 mt-1">
                {error}
              </p>
            )}
            <p className="text-xs text-gray-500 mt-2">
              <span className="font-bold text-gray-700">Note:</span> The remaining minutes can only be decreased. Leave the field untouched to keep the current value.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 pt-2">
             <button
               type="button"
               onClick={onClose}
               className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 font-medium transition-colors"
             >
               Cancel
             </button>
             <button
               type="submit"
               className="px-6 py-2.5 rounded-lg bg-[#885ABB] hover:bg-[#6f47a2] text-white font-medium transition-colors"
             >
               Update
             </button>
          </div>
        </form>
      </div>
    </div>
  );
};
